import { useState } from "react";
import { Link } from "react-router-dom";
import Resume from "../../assets/docs/Rakibul-Islam.pdf";
import ProfilePicture from "../../assets/images/Rakibul-Islam.jpg";
import Badge from "../Badge";
import BadgeGroup from "../BadgeGroup";
import FilterButton from "../FilterButton";
import Project from "../Project";
import ProjectList from "../projects/projects";
import SocialLinks from "../SocialLinks";

function Home() {
	const [projects, setProjects] = useState(ProjectList);

	const filterProjects = (cat) => {
		const category = cat.toLowerCase();
		if (category === "show all") {
			setProjects(ProjectList);
		} else {
			const filteredProject = ProjectList.filter(
				(item) => item.category.toLocaleLowerCase() === category
			);
			setProjects(filteredProject);
		}
	};

	return (
		<div className="body-font pt-12">
			<section className="wrapper">
				<div className=" flex flex-wrap justify-center md:flex-row flex-col">
					<div className="w-full md:w-4/12 mb-10 md:mb-0 flex flex-wrap justify-center md:justify-end">
						<div className="">
							<img
								className="object-cover object-center rounded-full w-32 h-32 md:w-48 md:h-48 ring-2 ring-gray-100 ring-offset-gray-800 ring-offset-4"
								alt="Rakibul Islam"
								src={ProfilePicture}
							/>
						</div>
					</div>
					<div className="w-full md:w-8/12 lg:pl-24 md:pl-16 flex flex-col md:items-start md:text-left items-center text-center">
						<SocialLinks />

						<h1 className="title-font sm:text-4xl text-3xl my-4 font-medium">
							<span className="border-b-2 border-red-600">
								Full-Stack
							</span>{" "}
							Web Developer
						</h1>
						<p className="mb-8 leading-relaxed">
							I design and code beautifully simple things, and I
							love what I do.
						</p>
						{/* skills */}
						<h4 className="text-xl font-semibol flex items-center mb-2">
							Skills{" "}
							<svg
								xmlns="http://www.w3.org/2000/svg"
								className="h-5 w-5 ml-1 text-red-600"
								viewBox="0 0 20 20"
								fill="currentColor"
							>
								<path
									fillRule="evenodd"
									d="M10.293 15.707a1 1 0 010-1.414L14.586 10l-4.293-4.293a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z"
									clipRule="evenodd"
								/>
								<path
									fillRule="evenodd"
									d="M4.293 15.707a1 1 0 010-1.414L8.586 10 4.293 5.707a1 1 0 011.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z"
									clipRule="evenodd"
								/>
							</svg>
						</h4>
						<div className="mb-5">
							<BadgeGroup>
								<Badge text="Python" />
								<Badge text="Javascript" />
							</BadgeGroup>
							<BadgeGroup>
								<Badge text="Django" />
								<Badge text="DRF" />
								<Badge text="React" />
								<Badge text="Redux" />
								<Badge text="Express" />
								<Badge text="NextJs" />
							</BadgeGroup>
							<BadgeGroup>
								<Badge text="HTML" />
								<Badge text="CSS" />
								<Badge text="Bootstrap" />
								<Badge text="Tailwind" />
								<Badge text="MUI" />
							</BadgeGroup>
							<BadgeGroup>
								<Badge text="Git" />
								<Badge text="Linux" />
								<Badge text="Postman" />
							</BadgeGroup>
						</div>
						<div className="flex justify-center space-x-4">
							<Link
								to="contact-me"
								className="btn btn-primary mail-btn"
							>
								Email Me
								<i className="far fa-paper-plane ml-2" />
							</Link>
							<a
								href={Resume}
								type="button"
								className="btn border-2 border-red-600 hover:bg-red-600 transition duration-300 ease-in-out"
							>
								Resume
								<i className="far fa-file-alt ml-2" />
							</a>
						</div>
					</div>
				</div>
			</section>

			{/* projects */}
			<section className="wrapper mt-6">
				<div className="">
					<div className="">
						<h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-center">
							Recent Projects
						</h1>
						<div className="flex flex-wrap justify-center space-x-4 my-8">
							<FilterButton
								text="Show All"
								filterProjects={filterProjects}
							/>
							<FilterButton
								text="Fullstack"
								filterProjects={filterProjects}
							/>
							<FilterButton
								text="Frontend"
								filterProjects={filterProjects}
							/>
							<FilterButton
								text="API"
								filterProjects={filterProjects}
							/>
						</div>
					</div>
					<div className="mt-16">
						<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
							{projects
								.slice(0)
								.reverse()
								.map((item) => (
									<Project key={item.id} item={item} />
								))}
						</div>
					</div>
				</div>
			</section>
		</div>
	);
}

export default Home;
